//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request, htmlToText } from '@/tools/index.js'
import { jssdk, isIphonex } from '@runwork/runwork-help'
import BottomNavigation from './components/navigation/Index.vue'
import Questions from './components/Questions.vue'
import EditableItem from './components/questions/EditableItem.vue'
import EditableSetting from './components/questions/EditableSetting.vue'
import EditBoard from './components/Edit.vue'
import SubmitDelete from './components/SubmitDelete.vue'
import SubmitRelease from './components/SubmitRelease.vue'
import ReleaseSuccess from './components/ReleaseSuccess.vue'
import { Conclusion, TitleWords } from './components/board/index.js'
import { EXISTENCE_COMPONENTS } from '@/tools'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  name: 'create-page',
  mixins: [downloadImgs],
  data() {
    return {
      currentIndex: 0,
      curOwnId: '',
      dataList: [],
      listNum: [],
      oldTab: [],
      tabData: [],
      pageForm: {
        questionnaireId: '',
        title: '问卷标题',
        titleFormat: '问卷标题',
        description: '感谢您参加本次问卷调查，现在我们就马上开始吧。',
        finishMessage: '您已完成本次问卷，感谢您的帮助与支持。',
        questions: [],
        pager: false,
      },
      popupItem: null,
      existence: EXISTENCE_COMPONENTS,
      isRW3: undefined, // 平台标志 3.0 true
    }
  },
  components: {
    EditableItem,
    EditableSetting,
    BottomNavigation,
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    questionnaireId() {
      return this.$route.query.questionnaireId
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.popupItem) {
      this.popupItem.close()
    }
    next()
  },
  async created() {
    const loading = new this.$Loading()
    try {
      await this.$nativeBridgeReady()
      await this.init()
      console.log('平台：', window.h5sdk ? 3.0 : 2.0)
      this.isRW3 = window.h5sdk ? true : false
      loading.close()
    } catch (err) {
      console.log(err)
      loading.close()
    }
  },
  methods: {
    init() {
      let promiseArr = [this.getQuestionnaire()]
      return Promise.all(promiseArr)
    },
    // 获取问题详情
    getQuestionnaire() {
      return this.$store
        .dispatch('getQuestionnaire', {
          questionnaireId: this.questionnaireId,
          userCode: this.user.ldap,
        })
        .then((res) => {
          this.pageForm = res
        })
    },
    // 返回
    closeWebApp() {
      this.$router.go(-1)
    },
    // 发布成功页面
    releaseSuccess(item) {
      let _this = this
      let popup = new this.$Popup(ReleaseSuccess, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        question: item,
        onadd(item) {
          _this.$router.push({
            name: 'questionnaire',
          })
          popup.close()
        },
      })
      this.popupItem = popup
    },
    // 选中项
    blockHandler(ownId) {
      this.curOwnId = ownId
    },
    // 底部操作
    actionHanlder(type) {
      switch (type) {
        case 'add':
          //题目
          this.addQuestion()
          break
        case 'release':
          //发布
          this.releaseTip()
          break
        case 'view':
          //预览
          this.review()
          break
        case 'setting':
          //设置
          this.setting()
          break
      }
    },
    // 预览
    review() {
      this.$router.push({
        name: 'detail',
        query: {
          questionnaireId: this.questionnaireId,
          isQuestion: 1,
          currentListStatus: 10, // 当前列表状态
        },
      })
    },
    // 结束语设置
    conclusionSetting() {
      let _this = this
      let popup = new this.$Popup(Conclusion, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        question: _this.pageForm,
        onadd(item) {
          _this.saveQuestion(() => {})
          popup.close()
        },
      })
      this.popupItem = popup
    },
    // 标题和欢迎语设置
    titleWords() {
      let _this = this
      let popup = new this.$Popup(TitleWords, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        question: _this.pageForm,
        onadd(item) {
          _this.pageForm.titleFormat = item.title
          _this.saveQuestion(() => {})
          popup.close()
        },
      })
      this.popupItem = popup
    },
    //设置
    setting() {
      this.$router.push({
        name: 'settings',
        query: {
          questionnaireId: this.questionnaireId,
          isAdd: true,
        },
      })
    },
    // 发布二次确认
    releaseTip() {
      let _this = this
      let popup = new this.$Popup(SubmitRelease, {
        position: 'bottom',
        isMaskClose: false,
        size: '120px',
        onsubmit(emitObj) {
          popup.close()
          _this.releaseQuestion((res) => {
            _this.releaseSuccess(res[0])
          })
        },
      })
      this.popupItem = popup
    },
    // 发布问题
    releaseQuestion(callback) {
      const loading = new this.$Loading()
      let question = {
        userCode: this.user.ldap,
        questionnaireId: this.questionnaireId,
      }
      return request('releaseQuestion', question)
        .then((res) => {
          typeof callback == 'function' ? callback(res) : ''
          this.getQuestionnaire()
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 每题的操作
    editHanlder({ type, item, index }) {
      switch (type) {
        case 'edit':
          //编辑
          this.edit(item, index)
          break
        case 'up':
          //上移
          this.changeArray(index, index - 1)
          break
        case 'down':
          //下移
          this.changeArray(index, index + 1)
          break
        case 'delete':
          //删除
          this.delete(item, index)
          break
      }
    },
    // 上移、下移
    changeArray(start, end) {
      let arr = this.pageForm.questions
      let s = arr[start]
      let e = arr[end]
      arr[start] = e
      arr[end] = s
      this.pageForm.questions = arr
      this.saveQuestion()
    },
    //删除项
    delete(item, index) {
      let _this = this
      let popup = new this.$Popup(SubmitDelete, {
        position: 'bottom',
        isMaskClose: false,
        size: '120px',
        onsubmit(emitObj) {
          _this.pageForm.questions.splice(index, 1)
          popup.close()
          _this.saveQuestion()
        },
      })
      this.popupItem = popup
    },
    // 编辑
    edit(item, index) {
      let _this = this
      let popup = new this.$Popup(EditBoard, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        question: item,
        onadd(item) {
          _this.pageForm.questions.splice(index, 1, item)
          _this.saveQuestion(() => {})
          popup.close()
        },
      })
      this.popupItem = popup
    },
    // 添加
    addQuestion() {
      let _this = this
      let popup = new this.$Popup(Questions, {
        position: 'bottom',
        isMaskClose: true,
        size: '260px',
        onchoose(item) {
          _this.pageForm.questions.push(item)
          _this.saveQuestion(() => {})
          popup.close()
        },
      })
      this.popupItem = popup
    },
    // 保存
    saveQuestion(callback) {
      const loading = new this.$Loading()
      let { title } = this.pageForm
      let titleFormat = htmlToText(title)
      let pageForm = { ...this.pageForm, titleFormat }
      let question = {
        ...pageForm,
        userCode: this.user.ldap,
        questionnaireId: this.questionnaireId,
      }
      return request('saveQuestion', question)
        .then((res) => {
          typeof callback == 'function' ? callback() : ''
          this.getQuestionnaire()
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    getTips() {
      console.log('获取提示...')
      let uat = 'https://uat.rwork.crc.com.cn/docs/dock9BSwPFosbD5j7navMrJJFlb'
      let prd = 'https://app.rwork.crc.com.cn/docs/dock9YvmLiHRmBlcdpPuYaSDzrc'
      window.location.href =
        process.env.VUE_APP_H5_ENV !== 'production' ? uat : prd
    },
  },
  mounted() {
    setTimeout(() => {
      this.replaceImg(`title-formateTitle`);
      this.replaceImg(`description-formateTitle`);
    }, 2000);
  },
}
